"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityBanner = exports.EntityBannerDefaultProps = exports.EntityBannerNameSizes = exports.EntityImageHeights = exports.EntityImageWidthsDesktopLarge = exports.EntityImageWidthsDesktop = exports.EntityBannerValueAlwaysShowIcons = exports.EntityBannerValueVariants = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var entity_title_1 = require("./entity-title");
var entity_value_1 = require("./entity-value");
var banner_controls_1 = require("../elements/banner-controls");
var entity_image_link_1 = require("./entity-image-link");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var react_spinners_1 = require("react-spinners");
var cell_header_1 = require("../elements/cell-header");
exports.EntityBannerValueVariants = {
  small: "default",
  embed: "embed",
  medium: "default",
  large: "banner",
  veryLarge: "banner"
};
exports.EntityBannerValueAlwaysShowIcons = {
  small: false,
  embed: true,
  medium: true,
  large: true,
  veryLarge: true
};
exports.EntityImageWidthsDesktop = {
  small: 118,
  embed: 118,
  medium: 198,
  large: 380,
  veryLarge: 592
};
exports.EntityImageWidthsDesktopLarge = {
  small: 123,
  embed: 123,
  medium: 198,
  large: 400,
  veryLarge: 592
};
exports.EntityImageHeights = {
  small: 69,
  embed: 80,
  medium: 116,
  large: 225,
  veryLarge: 328
};
exports.EntityBannerNameSizes = {
  small: 'tiny',
  embed: 'medium',
  medium: 'medium',
  large: 'large',
  veryLarge: 'veryLarge'
};
exports.EntityBannerDefaultProps = {
  size: 'medium',
  controls: [],
  showName: true,
  showLoading: true,
  showBadge: true,
  blended: false,
  alignItems: 'center',
  useImageViewer: false,
  showMenu: true,
  usePadding: true
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    \n    &:hover {\n      button.ellipsis-button {\n        visibility: visible;\n      }\n    }\n\n    ", "\n  "], ["\n    display: flex;\n    flex-direction: column;\n    \n    &:hover {\n      button.ellipsis-button {\n        visibility: visible;\n      }\n    }\n\n    ", "\n  "])), function (_a) {
    var blended = _a.blended;
    return blended && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background: ", ";\n    "], ["\n      background: ", ";\n    "])), theme_1.theme.COLOR('app-chrome'));
  }),
  desktop: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    flex-direction: row;\n    ", "\n  "], ["\n    flex-direction: row;\n    ", "\n  "])), function (props) {
    return (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      align-items: ", ";\n    "], ["\n      align-items: ", ";\n    "])), props.alignItems);
  })
});
var ImageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    width: 100%;\n    align-self: stretch;\n    flex-shrink: 0;\n    height: 142px;\n  "], ["\n    width: 100%;\n    align-self: stretch;\n    flex-shrink: 0;\n    height: 142px;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    height: 182px;\n  "], ["\n    height: 182px;\n  "]))),
  desktop: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    height: auto;\n    margin-right: ", ";\n    \n    ", "\n\n    ", "\n  "], ["\n    height: auto;\n    margin-right: ", ";\n    \n    ", "\n\n    ", "\n  "])), theme_1.theme.UNIT(2), function (_a) {
    var size = _a.size;
    return (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      height: ", "px;\n      width: ", "px;\n    "], ["\n      height: ", "px;\n      width: ", "px;\n    "])), exports.EntityImageHeights[size], exports.EntityImageWidthsDesktop[size]);
  }, function (_a) {
    var alignImage = _a.alignImage;
    return alignImage === 'end' && (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      order: 2;\n    "], ["\n      order: 2;\n    "])));
  }),
  desktopLarge: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    height: auto;\n    ", "\n  "], ["\n    height: auto;\n    ", "\n  "])), function (_a) {
    var size = _a.size;
    return (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      height: ", "px;\n      width: ", "px;\n    "], ["\n      height: ", "px;\n      width: ", "px;\n    "])), exports.EntityImageHeights[size], exports.EntityImageWidthsDesktopLarge[size]);
  })
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    display: flex;\n    flex-grow: 1;\n    flex-direction: column;\n    justify-content: space-between;\n    padding: ", " 0 ", " 0;\n    align-items: flex-start;\n    \n    ", "\n\n\n    ", "\n\n    ", "\n  "], ["\n    display: flex;\n    flex-grow: 1;\n    flex-direction: column;\n    justify-content: space-between;\n    padding: ", " 0 ", " 0;\n    align-items: flex-start;\n    \n    ", "\n\n\n    ", "\n\n    ", "\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4), function (_a) {
    var useDivider = _a.useDivider;
    return useDivider && (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n      ", ";\n    "], ["\n      ", ";\n    "])), theme_1.theme.V_DOT_BG());
  }, function (_a) {
    var size = _a.size;
    return size === 'small' && (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n      padding: ", ";\n    "], ["\n      padding: ", ";\n    "])), theme_1.theme.UNIT(3));
  }, function (_a) {
    var usePadding = _a.usePadding;
    return !usePadding && (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n      padding: 0;\n    "], ["\n      padding: 0;\n    "])));
  }),
  tablet: (0, styled_components_1.css)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    padding: ", " ", ";\n    flex-direction: row;\n\n    ", "\n\n    ", "\n\n    ", "\n\n    \n  "], ["\n    padding: ", " ", ";\n    flex-direction: row;\n\n    ", "\n\n    ", "\n\n    ", "\n\n    \n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(3), function (_a) {
    var alignItems = _a.alignItems;
    return (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n      align-items: ", ";\n    "], ["\n      align-items: ", ";\n    "])), alignItems);
  }, function (_a) {
    var size = _a.size;
    return size === 'small' && (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n      padding: ", ";\n    "], ["\n      padding: ", ";\n    "])), theme_1.theme.UNIT(3));
  }, function (_a) {
    var usePadding = _a.usePadding;
    return !usePadding && (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n      padding: 0;\n    "], ["\n      padding: 0;\n    "])));
  })
});
var InfoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    padding-right: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    padding-right: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var HeaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    margin: 0 0 ", " 0 !important;\n  "], ["\n    margin: 0 0 ", " 0 !important;\n  "])), theme_1.theme.UNIT(2))
});
var NameStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n    margin: 0 0 ", " 0 !important;\n    padding-bottom: 0 !important;\n    color: ", " !important;\n    \n    ", "\n  "], ["\n    margin: 0 0 ", " 0 !important;\n    padding-bottom: 0 !important;\n    color: ", " !important;\n    \n    ", "\n  "])), theme_1.theme.UNIT(2), theme_1.theme.COLOR('dark'), function (_a) {
    var hasChildren = _a.hasChildren;
    return !hasChildren && (0, styled_components_1.css)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n      margin-bottom: 0 !important;\n    "], ["\n      margin-bottom: 0 !important;\n    "])));
  })
});
var ControlsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n    flex-shrink: 0;\n    ", "\n  "], ["\n    flex-shrink: 0;\n    ", "\n  "])), function (_a) {
    var blended = _a.blended;
    return blended && (0, styled_components_1.css)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n      padding-top: 0;\n    "], ["\n      padding-top: 0;\n    "])));
  })
});
var SpinnerContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var size = _a.size;
    return (0, styled_components_1.css)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      height: ", "px;\n      width: ", "px;\n    "], ["\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      height: ", "px;\n      width: ", "px;\n    "])), exports.EntityImageHeights[size], exports.EntityImageHeights[size]);
  })
});
var SpinnerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var NameLoadingStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["\n    background: ", ";\n  "], ["\n    background: ", ";\n  "])), theme_1.theme.COLOR('text-subtle'))
});
var ValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_31 || (templateObject_31 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props.hasChildren && (0, styled_components_1.css)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["\n      margin-bottom: ", ";\n    "], ["\n      margin-bottom: ", ";\n    "])), theme_1.theme.UNIT(3));
  })
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Image: (0, styled_components_1.default)(entity_image_link_1.EntityImageLink)(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  Body: styled_components_1.default.div(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Info: styled_components_1.default.div(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), InfoStyles),
  Header: (0, styled_components_1.default)(cell_header_1.CellHeader)(templateObject_36 || (templateObject_36 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Name: (0, styled_components_1.default)(entity_title_1.EntityTitle)(templateObject_37 || (templateObject_37 = __makeTemplateObject(["", ""], ["", ""])), NameStyles),
  Value: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_38 || (templateObject_38 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  NameLoading: styled_components_1.default.span(templateObject_39 || (templateObject_39 = __makeTemplateObject(["", ""], ["", ""])), NameLoadingStyles),
  SpinnerContainer: styled_components_1.default.div(templateObject_40 || (templateObject_40 = __makeTemplateObject(["", ""], ["", ""])), SpinnerContainerStyles),
  Spinner: (0, styled_components_1.default)(react_spinners_1.BeatLoader)(templateObject_41 || (templateObject_41 = __makeTemplateObject(["", ""], ["", ""])), SpinnerStyles),
  Controls: (0, styled_components_1.default)(banner_controls_1.BannerControls)(templateObject_42 || (templateObject_42 = __makeTemplateObject(["", ""], ["", ""])), ControlsStyles)
};
var EntityBanner = function (props) {
  var className = props.className,
    children = props.children,
    showBadge = props.showBadge,
    entity = props.entity,
    size = props.size,
    controls = props.controls,
    showLoading = props.showLoading,
    blended = props.blended,
    useImageViewer = props.useImageViewer,
    entityTypeName = props.entityTypeName,
    showName = props.showName,
    showMenu = props.showMenu,
    usePadding = props.usePadding;
  var definition = entityTypeName ? (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName) : (0, use_entity_definition_1.useEntityDefinition)(entity);
  if (!definition) {
    return null;
  }
  var badge = props.badge === undefined ? entity.badge : props.badge;
  var imageSize = props.imageSize || size;
  var valueVariant = exports.EntityBannerValueVariants[size];
  var banner = definition.banner;
  var alwaysShowIcon = props.alwaysShowIcon !== undefined ? props.alwaysShowIcon : banner.alwaysShowIcon || exports.EntityBannerValueAlwaysShowIcons[size];
  var alignItems = banner.alignItems || props.alignItems;
  var useDivider = banner.useDivider || props.useDivider;
  var components = definition.components;
  var hasChildren = !!children;
  var title = "".concat(props.title || entity.typeLabel || definition.label).concat(props.subTitle ? " ".concat(props.subTitle) : '');
  return react_1.default.createElement(My.Container, {
    alignItems: alignItems,
    blended: blended,
    className: "shp-entity-banner ".concat(className)
  }, entity ? react_1.default.createElement(react_1.default.Fragment, null, alwaysShowIcon && (components.image ? react_1.default.createElement(components.image, {
    isBanner: true,
    blended: blended,
    size: imageSize,
    entity: entity
  }) : react_1.default.createElement(My.Image, {
    alignImage: banner.alignImage || 'start',
    useImageViewer: useImageViewer,
    size: imageSize,
    entity: entity
  }))) : showLoading && react_1.default.createElement(My.SpinnerContainer, {
    size: size
  }, react_1.default.createElement(My.Spinner, {
    size: exports.EntityImageHeights[size] / 3 - 10,
    color: "#DDD"
  })), react_1.default.createElement(My.Body, {
    usePadding: usePadding,
    className: "shp-entity-banner__body",
    useDivider: useDivider,
    alignItems: alignItems,
    blended: blended,
    size: size
  }, react_1.default.createElement(My.Info, null, react_1.default.createElement(My.Value, {
    showBadge: showBadge,
    showMenu: showMenu,
    hasChildren: hasChildren,
    label: title,
    alwaysShowIcon: alwaysShowIcon,
    badge: badge,
    variant: valueVariant,
    entity: entity
  }), children), react_1.default.createElement(My.Controls, {
    items: controls
  })));
};
exports.EntityBanner = EntityBanner;
exports.EntityBanner.defaultProps = exports.EntityBannerDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42;